import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { styleForm } from "./styles";
import {
  Grid,
  Paper,
  Switch,
  Button,
  Select,
  FormControl,
  Input,
} from "@material-ui/core";
import InputFormat from "../../partials/inputForm";
import DescriptionComponent from "../descriptionComponent";
import LabelForm from "../../partials/labelForm";
import InputImage from "./inputImage";
import MultiLevelCategoryList from "./multiLevelCategoryList";
import Snackbar from "../snackbar";
export class ProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data || {},
    };
  }
  async componentDidMount() {
    this.props.onRef(this);
  }
  componentWillReceiveProps = (nextProps) => {
    let _this = this;
    if (nextProps.data && nextProps.data.id !== this.state.data.id)
      this.setState(
        {
          data: nextProps.data,
        },
        function () {
          _this.DescriptionComponent.changeDescription(
            nextProps.data.description || ""
          );
        }
      );
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { data } = this.state;
    if (e.target.type === "checkbox") data[name] = e.target.checked;
    else data[name] = value;
    this.setState({
      data,
    });
  };
  handleSubComponentChange = (name, value) => {
    let state = this.state;
    let { data } = this.state;
    data[name] = value;
    this.setState({
      data,
    });
  };
  getInputFile = () => {
    return {
      files: this.InputImage.getFile(),
      src: this.InputImage.getSrc(),
      flagEdit: this.InputImage.flagEdit,
    };
  };
  handleSelectParentId = (parentId) => {
    let { data } = this.state;
    data.parent_id = parentId;
    this.setState({
      data,
    });
  };
  handleAddForm = (data) => {
    if (this.checkForm(data)) {
      this.props.handleAddForm(data);
    }
  };
  handleUpdateForm = (data) => {
    if (this.checkForm(data)) {
      this.props.handleUpdateForm(data);
    }
  };
  checkForm = (data) => {
    let { t } = this.props;
    if (!data.name) {
      this.mSnackbar.handleClick(
        t("product_category_please_fill_in_name"),
        "warning"
      );
      return false;
    }
    return true;
  };
  render() {
    const {
      t,
      classes,
      handleUpdateForm,
      handleDeleteForm,
      handleAddForm,
      notLevelCategories = [],
    } = this.props;
    let { data = {} } = this.state;
    let parent_id_find = notLevelCategories.find(
      (e) => e.id === data.parent_id
    );
    let parent_id = parent_id_find ? parent_id_find.name : "";
    console.log(data);
    return (
      <>
        <Paper className={classes.form}>
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <InputFormat
                required
                label={t("product_category_name")}
                name="name"
                value={data.name}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <InputFormat
                variant="outlined"
                select
                label={t("product_product_category_parent_category")}
                value={parent_id}
                SelectProps={{
                  renderValue: (value) => value,
                }}
              >
                <MultiLevelCategoryList
                  showOnModal={true}
                  defaultSelected={data.parent_id}
                  handleListItem={this.handleSelectParentId}
                  showRoot={true}
                  hidedId={data.id || ""}
                />
              </InputFormat>
              {/* <FormControl fullWidth={true} variant="outlined">
                <Select
                  labelId="demo-mutiple-checkbox-label"
                  id="demo-mutiple-checkbox"
                  name="category_ids"
                  value={parent_id}
                  label={"Parent Category"}
                  // onChange={this.handleChange}
                  input={<Input aria-label={"parent"} />}
                  renderValue={(selected) => selected}
                  // MenuProps={MenuProps}
                >
                  <MultiLevelCategoryList
                    showOnModal={true}
                    defaultSelected={data.parent_id}
                    handleListItem={this.handleSelectParentId}
                  />
                </Select>
              </FormControl> */}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <DescriptionComponent
                onRef={(id) => (this.DescriptionComponent = id)}
                title={t("product_category_description")}
                handleSubComponentChange={this.handleSubComponentChange}
                description={data.description}
                nameInput="description"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className={classes.containerSwitch}>
                <LabelForm label={t("product_category_enable")} />
                <Switch
                  name="enabled"
                  checked={data.enabled}
                  onChange={this.handleChange}
                  value={data.enabled}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <LabelForm label={t("product_category_image")} />
              <InputImage
                onRef={(id) => (this.InputImage = id)}
                defaultImg={data.image}
              />
              {/* <InputImage
                defaultImg={data.image}
                onRef={(id) => (this.InputImage = id)}
                style={classes}
                container="square"
                selectStorageMode={true}
              /> */}
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <InputFormat
                label={t("product_category_slug")}
                name="slug"
                value={data.slug}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <InputFormat
                label={t("product_category_page_title")}
                name="meta_title"
                value={data.meta_title}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <InputFormat
                label={t("product_category_meta_description")}
                name="meta_description"
                value={data.meta_description}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className={classes.containerBtn}>
                {handleUpdateForm && (
                  <Button
                    className={classes.button}
                    variant="contained"
                    color="primary"
                    onClick={() => handleUpdateForm(data)}
                  >
                    {t("product_update")}
                  </Button>
                )}
                {handleDeleteForm && (
                  <Button
                    className={classes.button}
                    variant="contained"
                    color="secondary"
                    onClick={() => handleDeleteForm(data)}
                  >
                    {t("product_delete")}
                  </Button>
                )}
                {handleAddForm && (
                  <Button
                    vclassName={classes.button}
                    variant="contained"
                    color="primary"
                    onClick={() => this.handleAddForm(data)}
                  >
                    {t("product_create")}
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  notLevelCategories: state.productCategory.notLevelCategories,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styleForm, { withTheme: 0 })(ProductMenu)
  )
);
